<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
      
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small" filterable clearable>
            <el-form-item style="width:28%">
            	<el-date-picker	v-model="query.date" type="datetimerange" style="width:100%"
              	range-separator="至"
              	start-placeholder="开始日期"
              	end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              	unlink-panels="false" @change="ischange=true">
            	</el-date-picker>
            </el-form-item>
            <el-form-item style="width:13%">
          	  <el-select v-model="query.brandid" clearable remote  filterable placeholder="按品牌" @change="ischange=true">	            
                  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                  </el-option>              
              </el-select>          
            </el-form-item>
            <el-form-item style="width:15%">
              <el-input placeholder="商品名称 / sku" v-model="query.key" clearable @keyup.enter.native="getList" @change="ischange=true" style="width:100%"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
                <el-button type="success" icon="el-icon-download" @click="getexportdata">导出</el-button>
            </el-form-item>
        </el-form>
        <el-tag type="danger" style="margin-top:10px">温馨提示：该同步记录为线上商城商品（京东商品）的价格与京东合作方的同步记录</el-tag>
				
        <div class="backborder2" style="margin-top:10px">
	          <el-table :data="lists" v-loading="listsloading">
                <el-table-column label="商品">
                    <template slot-scope="scope">
                        <div>
                            <img :src="scope.row.thumb" style="width:15%;float:left;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
                            <span style="float:left;width:70%;margin-left:2%">{{scope.row.name}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="sku" prop="sku" width="110"></el-table-column>
                <el-table-column label="京东销售价" width="140" align="center">
                    <template slot-scope="scope">
                        <span style="float:left;width:100%">更新前：{{scope.row.oldjdprice}}</span>
                        <span style="float:left;width:100%">更新后：{{scope.row.jdprice}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="协议销售价" width="140" align="center">
                    <template slot-scope="scope">
                        <span style="float:left;width:100%">更新前：{{scope.row.oldprice}}</span>
                        <span style="float:left;width:100%">更新后：{{scope.row.price}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="商城批发价" width="140" align="center">
                    <template slot-scope="scope">
                        <span style="float:left;width:100%">更新前：{{scope.row.oldsellprice}}</span>
                        <span style="float:left;width:100%">更新后：{{scope.row.sellprice}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="联营分销价" width="140" align="center">
                    <template slot-scope="scope">
                        <span style="float:left;width:100%">更新前：{{scope.row.oldagentprice}}</span>
                        <span style="float:left;width:100%">更新后：{{scope.row.agentprice}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="京东通知时间" prop="time" width="110" align="center"></el-table-column>
                <el-table-column label="本地同步时间" prop="updatetime" width="110" align="center"></el-table-column>
	          </el-table>
	        <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
        </div>


        <!-------------------------- 导出线上商城商品信息 --------------------------------------------->
        <el-dialog title="导出商品信息" :visible.sync="exportDialog" width="80%" top="5vh">
            <div style="float:left;width:100%;margin-top:10px;overflow:hidden;">
                <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	  	          <el-table :data="exportdata" v-loading="exportloading">
                    <el-table-column label="商品名称" prop="name"></el-table-column>
                    <el-table-column label="sku" prop="sku" width="120"></el-table-column>
                    <el-table-column label="京东销售价" width="120" align="center">
                        <template slot-scope="scope">
                            <span style="float:left;width:100%">旧：{{scope.row.oldjdprice}}</span>
                            <span style="float:left;width:100%">新：{{scope.row.jdprice}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="协议销售价" width="120" align="center">
                        <template slot-scope="scope">
                            <span style="float:left;width:100%">旧：{{scope.row.oldprice}}</span>
                            <span style="float:left;width:100%">新：{{scope.row.price}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="批发价" width="120" align="center">
                        <template slot-scope="scope">
                            <span style="float:left;width:100%">旧：{{scope.row.oldsellprice}}</span>
                            <span style="float:left;width:100%">新：{{scope.row.sellprice}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="分销价" width="120" align="center">
                        <template slot-scope="scope">
                            <span style="float:left;width:100%">旧：{{scope.row.oldagentprice}}</span>
                            <span style="float:left;width:100%">新：{{scope.row.agentprice}}</span>
                        </template>
                    </el-table-column>


                    <el-table-column label="京东通知时间" prop="time" width="110" align="center"></el-table-column>
                    <el-table-column label="本地同步时间" prop="updatetime" width="110" align="center"></el-table-column>
	              </el-table>	    	
	          </div>
            <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="exportDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-top:20px">确认导出</el-button>
            </div> 
        </el-dialog>


    </div>
    </transition>
</template>

<script>
export default {
  data () {
    return {
      actionauth:'', //功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Goods/index",
      ischange:false,
      brandlists:[],
      listsloading:false,
      lists:[],
      rows:0,
      query: {
          act:'getsyndata',
          token: this.$cookies.get('token'),
          date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate() +' 00:00:00',new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate() + ' 23:59:59'],
          brandid:'',
          key:'',
          isexport:0,
          p:1,
          rollpage:10
      },

      exportDialog:false,
      exportloading:false,
      exportdata:[],
      
    }
  },
    
  mounted(){  
      this.getactionauth();
      this.getBrand(); //获取品牌信息
      this.getList(); //获取同步信息列表
  },
  
  methods:{
      //获取功能权限
      getactionauth() {
        var data =this.$cookies.get('actionauth');
        data=JSON.parse(data);
          this.actionauth=data;
      },

      //获取品牌信息
      getBrand() {
          var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
          resource.query({act:'lists',token:this.$cookies.get('token'),p:1,rollpage:10000000}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.brandlists = JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },

      //获取同步信息
      getList() {
          if(this.ischange==true) {
              this.query.p=1;
              this.query.rollpage=10;
          }
          this.listsloading=true;
          this.query.isexport=0;
          var resource = this.$resource(this.url);		    
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
                  this.rows=parseInt(res.data.count);
                  this.listsloading=false;
                  if(this.ischange==true) this.ischange=false;
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.listsloading=false;
          });
      },

      pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getList();
      },

      //导出同步信息
      getexportdata() {
          this.exportDialog=true;
          this.exportloading=true;
          this.query.isexport=1;
          var resource = this.$resource(this.url);		    
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.exportdata = JSON.parse(Base64.decode(res.data.Data));
                  this.exportloading=false;
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.exportloading=false;
          });
      },

      /** 导出商品信息 **/
      sureoutput() {
          var result={tHeader:'',filterVal:'',name:'',data:''};
          result.tHeader=['商品名称','sku','更新前京东销售价','京东销售价','更新前协议销售价','协议销售价','更新前批发价','批发价','更新前分销价','分销价','京东通知时间','本地同步时间'];
          result.filterVal=['name','sku','oldjdprice','jdprice','oldprice','price','oldsellprice','sellprice','oldagentprice','agentprice','time','updatetime'];
          result.name="京东商品价格信息同步";
          result.data=this.exportdata;
          this.setsureoutput(result);
      },

      /** 确认导出订单信息 **/
      setsureoutput(item) {
          require.ensure([], () => {
            var { export_json_to_excel } = require('../../vendor/Export2Excel');
            var tHeader = item.tHeader;
            var filterVal = item.filterVal;
            
            var list = item.data;
            var data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, item.name);
            this.exportDialog=false;
          })
      },
        
      //导出表格数据
      formatJson(filterVal, jsonData) {
    　　  return jsonData.map(v => filterVal.map(j => v[j]));
    　},




  } 
}
</script>

<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>



// WEBPACK FOOTER //
// src/components/mall/exportsyndata.vue